export default "__VITE_ASSET__DaXBIFCR__"